// extracted by mini-css-extract-plugin
module.exports = {"mobileSegment__wrapper":"mobileSegment__wrapper-3QJy8","mobileSegment__info":"mobileSegment__info-1z5eq","mobileSegment__arrivalInfo":"mobileSegment__arrivalInfo-194fv"};